import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, useWatch, Controller } from 'react-hook-form';
import { useContext, useEffect, useMemo, useRef } from 'react';
import {
  DashboardProspectsDIRFiltersFormProps,
  DashboardProspectsDIRFiltersFormSchema,
} from './DashboardProspectsDIRFiltersForm.types';
import { getProspectsDIRFilterSchema } from './DashboardProspectsDIRFiltersForm.schema';
import { dashboardProspectsDIRFiltersFormData } from './DashboardProspectsDIRFiltersForm.data';
import Select from '../../../../../../commons/Select/Select';
import { ButtonColor, ButtonSize } from '../../../../../../designSystem/Button/Button.types';
import Button from '../../../../../../designSystem/Button/Button';
import { DashboardProspectsDIRContext } from '../../DashboardProspectsDIR.context';
import { SelectOption } from '../../../../../../commons/Select/Select.types';
import RSelect from 'react-select/dist/declarations/src/Select';

export default ({ closeModal }: DashboardProspectsDIRFiltersFormProps) => {
  const { commerciaux, setFilters } = useContext(DashboardProspectsDIRContext);

  const commercialIdsRef = useRef<RSelect[]>([]);

  useEffect(() => {
    commercialIdsRef.current = commercialIdsRef.current.slice(0, [...Array(4)].length);
  }, []);

  const formProps = useForm<DashboardProspectsDIRFiltersFormSchema>({
    resolver: yupResolver(getProspectsDIRFilterSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    handleSubmit,
    control,
    formState: { isValid, errors },
  } = formProps;

  const commercialIds = useWatch({
    control,
    name: 'commercialIds',
  });

  const isResetable = useMemo(() => Boolean(commercialIds), [commercialIds]);

  const onReinitialize = () => {
    console.log(commercialIdsRef.current);
    [...Array(2)].map((_, index) => {
      commercialIdsRef.current[index]?.clearValue();
    });
    setFilters({
      commercialIds: [],
    });
    // closeModal()
  };

  const onSubmit = handleSubmit(({ commercialIds }) => {
    setFilters((state) => ({
      ...state,
      commercialIds: (commercialIds as string[]) || [],
    }));
    closeModal();
  });

  const updatedFormData = useMemo(
    () =>
      dashboardProspectsDIRFiltersFormData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            case 'commercialIds':
              return {
                ...item,
                options: commerciaux?.map(({ id, firstName, lastName }) => ({
                  label: `${firstName} ${lastName}`,
                  value: id.toString(),
                })),
              };
            default:
              return item;
          }
        })
      ),
    [commerciaux]
  );

  return (
    <>
      <form className="form" style={{ width: 'calc(100% - var(--spacing-mToL) * 2)' }}>
        {updatedFormData.map((row, rowIndex) => (
          <div key={`row#${rowIndex}`} className="form__row">
            {row.map(({ name, placeholder, label, options, ...props }) => (
              <Controller
                key={`controlledInput#${rowIndex}`}
                name={name}
                render={({ field: { onChange } }) => (
                  <Select
                    // @ts-ignore
                    ref={(ref) => (commercialIdsRef.current[rowIndex] = ref)}
                    key={`select-${name}`}
                    placeholder={placeholder || ''}
                    error={errors[name]?.message as string}
                    {...{ label, options }}
                    {...props}
                    // @ts-ignore
                    onChange={(arr: SelectOption | SelectOption[]) => {
                      if (['department', 'region'].includes(name)) {
                        onChange((arr as SelectOption)?.value);
                      } else {
                        const values = (arr as SelectOption[]).map((item) => {
                          if (typeof item === 'string') {
                            return item;
                          } else {
                            return item.value;
                          }
                        });
                        onChange(values);
                      }
                    }}
                    isMulti
                  />
                )}
                {...{ control }}
              />
            ))}
          </div>
        ))}
        {isResetable && (
          <Button
            style={{ alignSelf: 'unset' }}
            onClick={(e) => {
              e.preventDefault();
              onReinitialize();
            }}
            size={ButtonSize.Large}
            color={ButtonColor.Contrast}>
            Réinitialiser
          </Button>
        )}
        <Button
          style={{ alignSelf: 'unset' }}
          onClick={(e) => {
            e.preventDefault();
            // setPaymentModalOpen(true);
            onSubmit();
          }}
          size={ButtonSize.Large}
          disabled={!isValid}>
          Appliquer
        </Button>
      </form>
    </>
  );
};
